<div class="container">
    <div class="delete-consumer-content">
        <p class="warning">Are you sure you want to delete {{ data.categoryData.name }}?</p>
        <div class="button-container">
            <button
                mat-raised-button
                matTooltip="Cancel Deleting Consumer"
                style="margin-right: 60px;"
                type="button"
                (click)="onNoClick()"
                class="button"
            >Cancel</button>
            <button
                mat-raised-button
                matTooltip="Delete Consumer"
                type="button"
                (click)="OnSubmit()"
                class="button"
            >Continue</button>
        </div>
    </div>
</div>
